<template>
  <div :class="[alignClass, animationClass]">
    <p :class="subtitleClass">
      {{ code }}
    </p>
    <h1
      v-if="type === 'h1'"
      :class="[titleClass]"
    >
      <slot />
    </h1>
    <h2
      v-if="type === 'h2'"
      :class="[titleClass]"
    >
      <slot />
    </h2>
    <h3
      v-if="type === 'h3'"
      :class="[titleClass]"
    >
      <slot />
    </h3>
  </div>
</template>

<script setup lang="ts">
import { computed, defineProps, PropType } from 'vue';

// Props
const props = defineProps({
  type: { type: String as PropType<'h1' |'h2' |'h3'>, default: 'h1' },
  code: { type: String, default: '' },
  align: { type: String as PropType<'left' | 'center' | 'right'>, default: 'center' },
  color: { type: String as PropType<'primary' | 'gray' | 'white'>, default: 'gray' },
  size: { type: String as PropType<'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '5xl' | '7xl'>, default: '5xl' },
  subtitleColor: { type: String as PropType<'primary' | 'gray' | 'white'>, default: 'primary' },
  animation: {
    type: String as PropType<'slideDown' | 'slideUp' | 'slideLeft' | 'slideRight' | 'fadeIn'>,
    default: '',
  },
});

// Data
const colorClasses = {
  primary: 'text-primary',
  gray: 'text-gray-900 dark:text-white',
  white: 'text-white',
};

const subtitleColorClasses = {
  primary: 'text-primary',
  gray: 'text-gray-500 dark:text-white',
  white: 'text-white',
};

const sizeClasses = {
  xs: 'text-xs sm:text-xs',
  sm: 'text-sm sm:text-sm',
  base: 'text-base sm:text-base',
  lg: 'text-lg sm:text-lg',
  xl: 'text-xl sm:text-xl',
  '2xl': 'text-2xl sm:text-2xl',
  '3xl': 'text-3xl sm:text-3xl',
  '5xl': 'text-5xl sm:text-5xl',
  '7xl': 'text-7xl sm:text-7xl',
};

const alignClasses = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

const animationMap = {
  slideDown: 'animate-slide-down',
  slideUp: 'animate-slide-up',
  slideLeft: 'animate-slide-left',
  slideRight: 'animate-slide-right',
  fadeIn: 'animate-fade-in',
};

// Computed
const subtitleClass = computed(() => `text-base font-semibold ${subtitleColorClasses[props.subtitleColor]}`);
const titleClass = computed(() => `mt-4 ${sizeClasses[props.size]} font-semibold tracking-tight text-balance ${colorClasses[props.color]}`);
const alignClass = computed(() => alignClasses[props.align]);
const animationClass = computed(() => animationMap[props.animation]);
</script>
